import { useState } from 'react';
import {Row , Col , Form , Input} from 'antd';
import { Link  } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import ErrorMessage from '../components/ErrorMessage';
import { register } from '../redux/actions/userActions2';
import AOS from 'aos';
import Spinner from '../components/Spinner';
import 'aos/dist/aos.css'; 


AOS.init();
function Register() {
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [password, setPassword] = useState('');
    const [confirmpassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState(null);

    const userRegister = useSelector((state) => state.userRegister);
    const { error } = userRegister;

    const {loading} = useSelector( state => state.alerts);
    const dispatch = useDispatch();
    
    const submitHandler = (e) => {
        e.preventDefault();

        if (password !== confirmpassword) {
            setTimeout(() => {
                setMessage('Passwords do not match');
            }, 2000);
        }
        else {
            dispatch(register(name, email, password));
        }
    };


    return (
        <div className='login'>
            {error && <ErrorMessage variant="danger">{error}</ErrorMessage>}
            {message && <ErrorMessage variant="danger">{message}</ErrorMessage>}

            { loading && (<Spinner />)}

            <Row gutter={16} className='d-flex align-items-center' >

                <Col lg={16} style={{position: 'relative'}}>
                    <img 
                        className='w-100'
                        data-aos='slide-left'
                        data-aos-duration='1500'
                        src="https://images.unsplash.com/photo-1485291571150-772bcfc10da5?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=928&q=80"
                    />
                    <h1 className='login-logo'><span className='smart'>SmartCars</span></h1>
                </Col>
                
                <Col lg={8} className='text-left p-5'>
                    <Form layout='vertical' className='login-form p-5' onSubmit={submitHandler}>
                        <h1>Register</h1>
                        <hr />
                        <Form.Item 
                            name="userName"
                            label="Name"
                            type="name"
                            value={name}
                            rules={[{required: true, message: 'Please enter your username!'},
                                { whitespace: true },
                                { min: 3 },]}
                            onChange={(e) => setName(e.target.value)}
                            hasFeedback>
                            <Input placeholder="Enter your name" />
                        </Form.Item>
                        
                        <Form.Item
                            name="email"
                            label="Email Address"
                            type="email"
                            value={email}
                            rules={[{required: true, message: 'Please enter your email address!'},
                                { type: 'email', message: 'Please enter a valid email' }
                            ]}
                            onChange={(e) => setEmail(e.target.value)}
                            hasFeedback>
                            <Input placeholder="Enter your email" />
                        </Form.Item>
                        
                        <Form.Item
                            name="password"
                            label='Password'
                            type='password'
                            value={password}
                            rules={[
                                {required: true, message: 'Please enter your password!'},
                                { min: 6 },
                                {
                                    validator: (_, value) =>
                                        value && value.includes('A')
                                            ? Promise.resolve()
                                            : Promise.reject(''),
                                },]}
                            onChange={(e) => setPassword(e.target.value)}
                            hasFeedback>
                            <Input.Password placeholder="Type your password"/>
                        </Form.Item>

                        <Form.Item
                            name="confirm password"
                            label="Confirm Password"
                            dependencies={['password']}
                            type="password"
                            value={confirmpassword}
                            rules={[
                                { required: true, message: 'Please enter your confirmation password!'},
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue('password') === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(
                                            'The two passwords that you entered does not match.'
                                        );
                                    },
                                }),]}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            hasFeedback>
                            <Input.Password placeholder="Confirm your password"/>
                        </Form.Item>

                        <button className="btn1 mt-2 mb-3" type="submit" onClick={submitHandler}>Register</button>
                        <br />
                    </Form>
                    
                    <div>
                        <p>Already Registered ? <Link to="/login"> Login </Link></p>
                        <hr />
                    </div>
                </Col>

            </Row>

        </div>
    );
}

export default Register;